import React from 'react';
import Button from '@atlaskit/button';

const LinkBtn = ({ btnName, onClick }: { btnName: string; onClick: () => void }) => (
  <Button testId={'link-button'} appearance={'link'} spacing={'none'} onClick={onClick}>
    {btnName}
  </Button>
);
export default LinkBtn;
